export const legalDesignElements = [
    {
        key: "filler",
        name: "Filler Flower",
    },
    {
        key: "focal",
        name: "Focal Flower",
    },
    {
        key: "disc",
        name: "Disc",
    },
    {
        key: "spike",
        name: "Spike",
    },
    {
        key: "foliage",
        name: "Foliage",
    },
    {
        key: "airy",
        name: "Airy Element",
    },
    {
        key: "grass",
        name: "Grass",
    },
    {
        key: "branch",
        name: "Branch",
    },
    {
        key: "large-scale",
        name: "Large Scale",
    },
    {
        key: "vine",
        name: "Vine",
    },
    {
        key: "evergreen",
        name: "Evergreen",
    },
    {
        key: "berry",
        name: "Berry",
    },
    {
        key: "gourd",
        name: "Gourd",
    },
    {
        key: "seed-pod",
        name: "Seed Pod",
    },
];
//# sourceMappingURL=cut-flowers.js.map